import React, { useEffect } from 'react';
import Footer from '../../Components/Footer/Footer';
import Header from '../../Components/Header/Header';
import '../../assets/css/Home.css'
import TopSlider from '../../Components/Home/TopSlider';
import OurQuality from '../../Components/Home/OurQuality';
import OurPackages from '../../Components/Home/OurPackages';
import AmazingProcess from '../../Components/Home/AmazingProcess';
import JoinNow from '../../Components/Home/JoinNow';
import RecentPodcast from '../../Components/Home/RecentPodcast';
import Testimonials from '../../Components/Home/Testimonials';
import Blogs from '../../Components/Home/Blogs';
import { useDispatch, useSelector } from 'react-redux';
import { InfoAfterLogin } from '../../Redux/Auth/Auth_Action';
// import ShowInterests from '../../Components/Home/ShowInterests';


const HomePage = () => {
    const ReduxToken = useSelector((state) => state?.Auth?.token);
    const dispatch = useDispatch();
    const allState = useSelector((state) => state);

    // console.log('tootootoot', allState);
    const getPackageinfo = () => {
        dispatch(InfoAfterLogin(ReduxToken))
            .then((res) => {
                console.log(res,'from home page api call active subs')
            })
            .catch((e) => {
                console.log("errrrrr", e);
                dispatch({ type: "DEL_TOKEN" });
            })
    }

    useEffect(() => {
        if (allState?.Auth.token) {
            getPackageinfo();
        }
    }, [])

    useEffect(() => {
        window.scroll(0, 0);
    }, []);

    return (
        <div className='home'>
            {/* first section starts*/}
            {/* <section className='dialog_home_intrsts'>
                <ShowInterests/>
            </section> */}

            <section className='home-bg-first '>
                <Header />
                <div className='container mt-5'>
                    <TopSlider />
                </div>
            </section>

            {/* first section ends*/}

            {/* ourquality section starts*/}

            <section className='ourQuality'>
                <div className='container'>
                    <OurQuality />
                </div>
            </section>

            {/* ourquality section ends*/}

            {/* OurPackages section starts*/}

            <section className='home-bg-third pos-rel overflow-hide-x'>
                <div className='bg-packages-shahke'>

                </div>
                <div className='container'>
                    <OurPackages />
                </div>
            </section>

            {/* OurPackages section ends*/}

            {/* AmazingProcess section starts*/}

            <section className='home-bg-fourth'>
                <div className='container'>
                    <AmazingProcess />
                </div>
            </section>

            {/* AmazingProcess section ends*/}

            {/* JoinNow section starts*/}

            <section className='home-bg-fifth pos-rel overflow-hide-x'>
                <div className='bg-joinnow-shahke'>

                </div>
                <div className='container pt-5 pt-rz-hm-joim'>
                    <JoinNow />
                </div>
            </section>

            {/* JoinNow section starts*/}

            {/* RecentPodcast section starts*/}

            <section className='home-bg-sixth'>
                <div className='container-fluid'>
                    <RecentPodcast />
                </div>
            </section>

            {/* RecentPodcast section ends*/}

            {/* Testimonials section starts*/}

            <section className='home-bg-seventh pos-rel overflow-hide-x'>
                <div className='bg-testimonial-shahke'>

                </div>
                <div className='container'>
                    <Testimonials />
                </div>
            </section>

            {/* Testimonials section ends*/}

            {/* Blog section start*/}

            <section className='home-bg-eight'>
                <div className='container'>
                    <Blogs />
                </div>
            </section>

            {/* Blog section ends*/}
            <Footer />
        </div>
    )
}

export default HomePage;